export enum ZyusetuEditType {
  Edit = "Edit",
  Review = "Review",
  ReadOnly = "ReadOnly",
}
